// Timerecordtype-IDs, die in der SFG-Arbeitszeiterfassung relevant sind.
// Müssen mit der Backend-Enum `TimerecordtypeIdNameEnum` übereinstimmen.
export const TIMERECORDTYPE_ID_ARBEIT = 1;
export const TIMERECORDTYPE_ID_KOMPENSATION = 5;

// Nur Einträge dieser Typen (oder ohne gesetzten Typ) dürfen in der App bearbeitet oder gelöscht werden.
// Pausen (11) und bezahlte Pausen (12) sind bewusst ausgenommen.
export const EDITABLE_TIMERECORDTYPE_IDS: readonly number[] = [TIMERECORDTYPE_ID_ARBEIT, TIMERECORDTYPE_ID_KOMPENSATION];
